<template>
  <div class="">
    <Navbar />

    <div id="main">
      <div class="container">
        <div class="row align-items-center text-center" style="background:#000;">
          <div class="col-md-12 px-0" v-lazy-container="{ selector: 'img' }">
            <img data-src="/logo/contact.png" data-loading="/logo/contact.jpg"
              style="width:100%;max-height:495px;object-fit:cover;">
          </div>
        </div>
      </div>

      <div class="container">
        <div class="row">
          <div id="detail"
            style="min-height:200px; font-size:16px; background: linear-gradient(#1b1b1b, #040607); color:#fff;">
            <p>We're always eager to welcome driven, creative, and motivated individuals to our team. We believe that a
              positive and open-minded environment fosters creativity. If you require more information about our
              services
              or have any general questions, please feel free to reach out to us.</p>
            <div class="row mb-2">
              <div class="block-content col-md-4 col-sm-12 text-center px-3 mb-2">
                <div class="bg-white pt-5" style="height:380px;border-radius:20px 0 20px 0;">
                  <img class="mb-3" src="https://admin.idiomtalent.com/GeneralInquariedIcon.png?v=0" width="80">
                  <div class="px-4">
                    <h6 class="mb-2 font-black" style="min-height:50px;font-weight:bold;">GENERAL INQUIRIES</h6>
                    <a href="mailto:info@idiomtalent.com" style="font-size:15px;">info@idiomtalent.com</a>
                  </div>
                </div>
              </div>
              <div class="block-content col-md-4 col-sm-12 text-center px-3 mb-2">
                <div class="bg-white pt-5" style="height:380px;border-radius:20px 0 20px 0;">
                  <img class="mb-3" src="https://admin.idiomtalent.com/BusinessInquariesIcon.png?v=0" width="80">
                  <div class="px-4">
                    <h6 class="mb-2 font-black"
                      style="min-height:50px;font-weight:bold;line-height:18pt;margin-top:-17px;">CASTING OR <br>NEW
                      BUSINESS INQUIRIES</h6>
                    <br>
                    <a href="mailto:talentdept@idiomtalent.com" style="font-size:15px;">talentdept@idiomtalent.com</a>
                  </div>
                </div>
              </div>
              <div class="block-content col-md-4 col-sm-12 text-center px-3 mb-2">
                <div class="bg-white pt-5" style="height:380px; border-radius:20px 0 20px 0;">
                  <img class="mb-3" src="https://admin.idiomtalent.com/ReptInquariesIcon.png?v=0" width="80">
                  <div class="px-4">
                    <h6 class="mb-2 font-black" style="min-height:50px;font-weight:bold;">REPRESENTATION INQUIRIES</h6>
                    <a href="mailto:representation@idiomtalent.com"
                      style="font-size:15px;">representation@idiomtalent.com</a>
                    <br><br>
                    <small class="font-black">
                      If you're seeking voiceover representation, you may submit your material to us directly or utilize
                      our talent submission form for a faster response.
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>

  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'Contact',
  components: { Navbar, Footer },
}
</script>

<style scoped>
/* #main { background-color:#aa4d8e !important; } */
#main {
  background-color: #894073 !important;
}

#detail {
  padding: 50px;
  width: 100% !important
}

@media (max-width: 600px) {
  #detail {
    padding: 25px;
  }
}

#detail .block-content {
  font-family: "Raleway", "Helvetica Neue", Helvetica, Arial, sans-serif;
}

.font-black {
  color: black;
}
</style>
